import React from 'react';
import propTypes from 'prop-types';
import { isFunction } from '@dateam/ark';
import { Button } from 'shared-ui';
import { PlusIcon } from 'components/Icons';
import PlotSelector from 'components/PlotSelector';
import styles from '../../../InspectionEditScreen.module.scss';

type Props = {
    onPlotAdded?: (plotIds: number[]) => unknown;
};

const PlotSectionHeader: React.FC<Props> = ({ onPlotAdded }: Props) => {
    const [showPlotSelector, setShowPlotSelector] = React.useState(false);

    const addPlot = React.useCallback((plotIds: number[]) => {
        setShowPlotSelector(false);

        if (isFunction(onPlotAdded)) onPlotAdded(plotIds);
    }, [onPlotAdded, setShowPlotSelector]);

    return (
        <div>
            <Button
                color="primary"
                startIcon={(<PlusIcon />)}
                onClick={() => setShowPlotSelector(true)}
            >
                Ajouter des parcelles
            </Button>

            {showPlotSelector && (
                <PlotSelector
                    onClose={() => setShowPlotSelector(false)}
                    onAdd={addPlot}
                />
            )}
        </div>
    );
};

PlotSectionHeader.propTypes = {
    onPlotAdded: propTypes.func
};

PlotSectionHeader.defaultProps = {
    onPlotAdded: undefined
};

export default PlotSectionHeader;
